import Vue from 'vue'
import VueRouter from 'vue-router'
import { getAccessToken } from '../api/auth'
import store from '../store'
import { firstPermittedPath } from './menus'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('../views/Login.vue'),
      meta: { public: true },
    },
    {
      path: '/',
      component: () => import('../views/layout/Layout.vue'),
      redirect: '/products',
      children: [
        {
          path: 'products',
          name: 'products',
          component: () => import('../views/products/Index.vue'),
          meta: { title: '严选产品', permission: 'Api.AdminMenus.Products' },
        },
        {
          path: 'community/posts',
          name: 'community-posts',
          component: () => import('../views/community/Posts.vue'),
          meta: { title: '社区软文', permission: 'Api.AdminMenus.CommunityPosts' },
        },
        {
          path: 'community/comments',
          name: 'community-comments',
          component: () => import('../views/community/Comments.vue'),
          meta: { title: '评论审核', permission: 'Api.AdminMenus.CommunityComments' },
        },
        {
          path: 'community/categories',
          name: 'community-categories',
          component: () => import('../views/community/Categories.vue'),
          meta: { title: '社区频道', permission: 'Api.AdminMenus.CommunityCategories' },
        },
        {
          path: 'community/featured-cards',
          name: 'community-featured-cards',
          component: () => import('../views/community/FeaturedCards.vue'),
          meta: { title: '社区专题卡片', permission: 'Api.AdminMenus.CommunityFeaturedCards' },
        },
        {
          path: 'community/treehole',
          name: 'community-treehole',
          component: () => import('../views/community/TreeHole.vue'),
          meta: { title: '树洞管理', permission: 'Api.AdminMenus.CommunityTreeHole' },
        },
        {
          path: 'doctor/my-patients',
          name: 'doctor-my-patients',
          component: () => import('../views/patients/MyPatients.vue'),
          meta: { title: '我的患者', permission: 'Api.AdminMenus.MyPatients' },
        },
        {
          path: 'doctor/assistants',
          name: 'doctor-assistants',
          component: () => import('../views/patients/MyAssistants.vue'),
          meta: { title: '我的团队', permission: 'Api.AdminMenus.MyAssistants' },
        },
        {
          // 患者在小程序申请更换负责自己的助理，专家在这里批/驳（医助只读）。
          path: 'doctor/assistant-changes',
          name: 'doctor-assistant-changes',
          component: () => import('../views/patients/AssistantChangeReviews.vue'),
          meta: { title: '医助变更审核', permission: 'Api.AdminMenus.AssistantChangeReview' },
        },
        {
          path: 'doctor/mall',
          name: 'doctor-mall',
          component: () => import('../views/patients/Mall.vue'),
          meta: { title: '积分商城', permission: 'Api.AdminMenus.DoctorMall' },
        },
        {
          // 医生本人发专家馆文章 / 视频（与小程序「专家发布中心」对等），权限说明见 router/menus.js。
          path: 'doctor/publish',
          name: 'doctor-publish',
          component: () => import('../views/patients/ExpertPublish.vue'),
          meta: { title: '发布中心', permission: 'Api.AdminMenus.MyPatients' },
        },
        {
          path: 'doctor/chat-qa',
          name: 'doctor-chat-qa',
          component: () => import('../views/patients/ChatQa.vue'),
          meta: { title: '自动应答话术', permission: 'Api.AdminMenus.ChatQaRules' },
        },
        {
          path: 'doctor/follow-up-auto-inquiry',
          name: 'doctor-follow-up-auto-inquiry',
          component: () => import('../views/patients/FollowUpAutoInquiry.vue'),
          meta: { title: '自动回访话术', permission: 'Api.AdminMenus.FollowUpAutoInquiry' },
        },
        {
          path: 'experts/applications',
          name: 'expert-applications',
          component: () => import('../views/experts/Applications.vue'),
          meta: { title: '专家申请审核', permission: 'Api.AdminMenus.ExpertApplications' },
        },
        {
          // 已认证专家 + 专家码，与「专家申请审核」共用同一菜单权限（审核通过的结果页）。
          path: 'experts/certified',
          name: 'expert-certified',
          component: () => import('../views/experts/CertifiedExperts.vue'),
          meta: { title: '专家列表', permission: 'Api.AdminMenus.ExpertApplications' },
        },
        {
          path: 'experts/patient-assignment',
          name: 'expert-patient-assignment',
          component: () => import('../views/experts/PatientAssignment.vue'),
          meta: { title: '患者分流', permission: 'Api.AdminMenus.ExpertPatientAssignment' },
        },
        {
          path: 'experts/contents',
          name: 'expert-contents',
          component: () => import('../views/experts/Contents.vue'),
          // 直播默认关着（系统功能管理 → 暂未开放的功能），标题里先不提；存量直播内容仍在列表中
          meta: { title: '专家内容（视频/文章）', permission: 'Api.AdminMenus.ExpertContents' },
        },
        {
          path: 'points/settings',
          name: 'points-settings',
          component: () => import('../views/points/Settings.vue'),
          meta: { title: '积分配置', permission: 'Api.AdminMenus.PointsSettings' },
        },
        {
          path: 'ai/prompts',
          name: 'ai-prompts',
          component: () => import('../views/ai/Prompts.vue'),
          meta: { title: 'AI 提示词维护中心', permission: 'Api.AdminMenus.AiPrompts' },
        },
        {
          path: 'knowledge-base/documents',
          name: 'kb-documents',
          component: () => import('../views/knowledgeBase/Documents.vue'),
          meta: { title: '知识库', permission: 'Api.AdminMenus.KnowledgeBase' },
        },
        {
          path: 'metaphysics/tools',
          name: 'metaphysics-tools',
          component: () => import('../views/metaphysics/Tools.vue'),
          meta: { title: '玄学工具目录', permission: 'Api.AdminMenus.MetaphysicsTools' },
        },
        {
          path: 'metaphysics/tarot',
          name: 'metaphysics-tarot',
          component: () => import('../views/metaphysics/TarotCards.vue'),
          meta: { title: '塔罗牌库', permission: 'Api.AdminMenus.MetaphysicsTarot' },
        },
        {
          path: 'metaphysics/oracle-slips',
          name: 'metaphysics-oracle-slips',
          component: () => import('../views/metaphysics/OracleSlips.vue'),
          meta: { title: '灵签签文', permission: 'Api.AdminMenus.MetaphysicsOracleSlips' },
        },
        {
          path: 'metaphysics/divination-logs',
          name: 'metaphysics-divination-logs',
          component: () => import('../views/metaphysics/DivinationLogs.vue'),
          meta: { title: '占卜历史', permission: 'Api.AdminMenus.MetaphysicsDivinationLogs' },
        },
        {
          path: 'feedback',
          name: 'feedback',
          component: () => import('../views/feedback/Feedback.vue'),
          meta: { title: '用户反馈', permission: 'Api.AdminMenus.Feedback' },
        },
        {
          path: 'system/users',
          name: 'system-users',
          component: () => import('../views/system/Users.vue'),
          meta: { title: '用户管理', permission: 'AbpIdentity.Users' },
        },
        {
          path: 'system/roles',
          name: 'system-roles',
          component: () => import('../views/system/Roles.vue'),
          meta: { title: '角色管理', permission: 'AbpIdentity.Roles' },
        },
        {
          path: 'system',
          name: 'system-settings',
          component: () => import('../views/system/Settings.vue'),
          meta: { title: '系统功能管理', permission: 'Api.AdminMenus.SystemSettings' },
        },
      ],
    },
    {
      path: '*',
      redirect: '/products',
    },
  ],
})

router.beforeEach(async (to, _from, next) => {
  if (to.meta.public) return next()
  if (!getAccessToken()) {
    return next({ name: 'login', query: { redirect: to.fullPath } })
  }

  // 登录后首次导航先拉授权策略（application-configuration），驱动菜单显隐与本守卫。
  if (store.state.grantedPolicies === null) {
    try {
      await store.dispatch('loadAppConfig')
    } catch {
      // 拉取失败（后端瞬断等）不拦路由：菜单可能显示不全，页面接口会自行报错。
    }
  }

  // 无权限页面 → 落到第一个有权限的菜单；一个都没有则放行（页面接口自会 403 提示）。
  const required = to.meta.permission
  if (required && store.state.grantedPolicies && !store.state.grantedPolicies[required]) {
    const fallback = firstPermittedPath((p) => store.getters.can(p))
    if (fallback && fallback !== to.path) return next(fallback)
  }
  next()
})

export default router
